import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout, usePageData} from '../../core'
import { getDemoSectionAttributes, isDemoSectionVisible } from '../../../../app/modules/demo/demoMode'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean,
  children?: React.ReactNode
  pagePermissions?: string[]
  activePaths?: string[]
  demoSectionId?: string
}

const AsideMenuItemWithSub: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  pagePermissions = [],
  activePaths = [],
  demoSectionId,
}) => {
  const {pathname} = useLocation()
  const isActive = [to, ...activePaths].some((path) => checkIsActive(pathname, path))
  const {config} = useLayout()
  const {aside} = config
  const [canView, setCanView] = useState(true);
  const { currentUser: { activePages } } = usePageData();

  useEffect(() => {
    if (Array.isArray(pagePermissions) && pagePermissions.length > 0 && activePages) {
      const allowed = pagePermissions.some(page => activePages.some(activePage => activePage.name === page));
      setCanView(allowed);
    } else {
      setCanView(true);
    }
  }, [pagePermissions, activePages]);

  if (!canView)
    return <> </>;

  if (!isDemoSectionVisible(demoSectionId)) {
    return <></>
  }

  const demoAttributes = getDemoSectionAttributes(demoSectionId) ?? {}

  return (
    <div
      {...demoAttributes}
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link rounded-3 px-4 py-3' title={title} aria-label={title}>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon pe-none'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3 pe-none', fontIcon)}></i>}
  <span className='menu-title fw-semibold'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {AsideMenuItemWithSub}
